import { Box, Spinner, Text } from "@primer/react";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authApi } from "../../api/auth/authApi";
import { NotifyHelper } from "../../helpers/toast";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { rootActions } from "../../state/actions/rootActions";

/**
 * Đích 302 sau khi đăng nhập Google/Microsoft thành công. Backend redirect về đây kèm
 * `?code=<one-time>` → đổi lấy JWT (POST /auth/oauth/exchange) → LOGIN_SUCCESS → vào trang chủ.
 *
 * Dùng one-time code thay vì nhét JWT vào URL để tránh token lọt vào log/history/referrer.
 * Guard useRef chống StrictMode gọi exchange 2 lần (code dùng-một-lần, lần 2 sẽ fail).
 */
const OAuthCallbackPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;

        const code = params.get("code");
        if (!code) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            const res = await authApi.OAuthExchange(code);
            if (res.is_success && res.data) {
                NotifyHelper.Success(`Chào ${res.data.user.ho_ten}!`);
                dispatch(rootActions.auth.LOGIN_SUCCESS(res.data));
                navigate("/", { replace: true });
            } else {
                NotifyHelper.Error(res.message || "Đăng nhập thất bại.");
                navigate("/login", { replace: true });
            }
        })();
    }, [params, dispatch, navigate]);

    return (
        <Box
            sx={{
                width: "100vw",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 3,
                bg: "#E7E5EE",
            }}
        >
            <Spinner size="large" />
            <Text sx={{ color: "#333", fontWeight: "bold" }}>Đang hoàn tất đăng nhập…</Text>
        </Box>
    );
};

export default OAuthCallbackPage;
